import React, { useRef, useState } from 'react';
import axios from 'axios';
import '../styles/contact.css';

const ContactForm =({ language }) => {
  const form = useRef();
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const sendMessage = async (e) => {
    e.preventDefault();
    setSubmitted(false);
    setError('');

    const formData = new FormData(form.current);
    const data = Object.fromEntries(formData.entries());

    try {
await axios.post(`${process.env.REACT_APP_API_URL}/api/contact`, data);
      setSubmitted(true);
      form.current.reset();
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <>
      <div className="contact-form bg-light shadow-sm p-4 rounded">
       <h3 className="mb-4 fw-bold" style={{ color: '#1e3a8a' }}>
      {language === 'en' ? 'Contact Blue Nest Hotel' : 'ብሉ ኔስት ሆቴልን ያግኙ'}
    </h3>
    <form ref={form} onSubmit={sendMessage}>
      <div className="mb-3"style={{ color: '#4D784E' }}>
        <input 
          type="text" 
          name="user_name" 
          className="form-control" 
          placeholder={language === 'en' ? 'Your full name' : 'ሙሉ ስምዎ'} 
          required 
        />
      </div>
      <div className="mb-3"style={{ color: '#4D784E' }}>
        <input 
          type="email" 
          name="user_email" 
          className="form-control" 
          placeholder={language === 'en' ? 'Enter a valid email' : 'ትክክለኛ  ኢሜይል ያስገቡ'} 
          required 
        />
      </div>
      <div className="mb-3"style={{ color: '#4D784E' }}>
        <input 
          type="text" 
          name="phone_no" 
          className="form-control" 
          placeholder={language === 'en' ? 'Enter your phone number' : 'ስልክ ቁጥርዎን ያስገቡ'} 
          required 
        />
      </div>
      <div className="mb-3"style={{ color: '#4D784E' }}>
        <textarea 
          name="message" 
          rows="4" 
          className="form-control" 
          placeholder={language === 'en' ? 'Questions about rooms, dining, or services?' : 'ስለ ክፍሎች፣ ምግብ ወይም አገልግሎቶች ጥያቄዎች?'} 
          required
        ></textarea>
      </div>
      <button type="submit" className="btn w-100" style={{ backgroundColor: '#2563eb', borderColor: '#2563eb', color: 'white' }}>
        {language === 'en' ? 'Send Message' : 'መልእክት ላክ'}
      </button>
    </form>
  </div>

  {submitted && (
    <div className="alert alert-success mt-4" role="alert">
      ✅ {language === 'en' 
        ? 'Thank you! Your message has been sent.' 
        : 'እናመሰግናለን! መልእክትዎ ተልኳል።'}
    </div>
  )}
    
      {error && (
        <div className="alert alert-danger mt-4" role="alert">
          ❌ {error}
        </div>
      )}
    </>
  );
};

export default ContactForm;
